// extracted by mini-css-extract-plugin
module.exports = {"security":"PaymentSecurity_security__lMd3A","icon":"PaymentSecurity_icon__1ExZd"};